import { principles, siteMeta, voices } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function About() {
  return (
    <section id="about" className="relative bg-paper-100/70 py-16 md:py-24 scroll-mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeading
          eyebrow="ABOUT US · 关于我们"
          title={`${siteMeta.brand}：让吃瓜不止于看热闹`}
          desc="我们是一群对娱乐圈现象保持好奇的观察者。不做爆料站、不搞流量审判，只把每一次人设崩塌当成观察人性与媒介的样本，理性拆解，克制表达。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {principles.map((p) => (
              <div
                key={p.title}
                className="flex gap-4 rounded-2xl border border-paper-200 bg-paper-50 p-5"
              >
                <span className="grid place-items-center shrink-0 w-11 h-11 rounded-full bg-ink-900 text-gold-400">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-semibold text-ink-900">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-ink-700/75 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col justify-between gap-5 rounded-2xl border border-paper-200 bg-paper-50 p-6 md:p-7">
            <div>
              <p className="font-display text-xl text-coral-700">我们想跟你聊聊</p>
              <p className="mt-3 text-ink-700/85 leading-relaxed">
                无论是补充事件线索、投稿深度解读，还是单纯的吃瓜心得，都欢迎来信。
                我们承诺：每一封邮件都会认真阅读，但不会把任何爆料当作事实来传播。
              </p>
            </div>
            <div className="flex flex-col gap-3 text-sm">
              <a
                href="mailto:hello@collapse.example.com"
                className="inline-flex items-center gap-3 rounded-xl border border-paper-200 bg-paper-100/70 px-4 py-3 hover:border-coral-200 hover:bg-coral-50 transition-colors"
              >
                <i className="ri-mail-line text-coral-600"></i>
                hello@collapse.example.com
                <span className="ml-auto text-xs text-ink-700/50">商务 · 投稿</span>
              </a>
              <div className="inline-flex items-center gap-3 rounded-xl border border-paper-200 bg-paper-100/70 px-4 py-3 text-ink-700/80">
                <i className="ri-time-line text-coral-600"></i>
                更新频率：每周一三五发布
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {voices.map((v) => (
            <figure
              key={v.name}
              className="flex flex-col rounded-2xl border border-paper-200 bg-paper-50 p-6"
            >
              <i className="ri-double-quotes-l text-4xl text-gold-400 leading-none"></i>
              <blockquote className="mt-3 text-ink-800 leading-relaxed flex-1">
                {v.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-paper-200">
                <span className="grid place-items-center w-10 h-10 rounded-full bg-coral-500 text-white font-semibold">
                  {v.name.slice(0, 1)}
                </span>
                <div className="leading-tight">
                  <p className="font-semibold text-ink-900 text-sm">{v.name}</p>
                  <p className="text-xs text-ink-700/55 mt-0.5">{v.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}